import axios from 'axios';
import { jsonrepair } from 'jsonrepair';
import { extractTitle } from './utils';

const aritReqUrl = process.env.NEXT_PUBLIC_RELEVANCE_ARIT_API_URL;
const imsReqUrl = process.env.NEXT_PUBLIC_RELEVANCE_IMS_API_URL;

async function createArit({ taaw, text }: { taaw: string; text: string }) {
  const urlRegex = /^(https?:\/\/)(?!localhost)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}([\/?#][^\s]*)?$/;
  const urlCheck = urlRegex.test(text);
  const { data } = await axios.post(aritReqUrl!, {
    params: {
      taaw,
      text,
      text_check: !urlCheck,
      url_check: urlCheck,
    },
    project: '4950a1c24bab-49af-beb3-d127e70c4c59',
  });
  
  if (!data?.output?.answer) {
    throw new Error('Invalid ARIT API response: missing output.answer');
  }
  
  const answer = data.output.answer;

  const reportTitle = extractTitle(answer) || 'Untitled ARIT Report';
  const returnData = {
    status: data.status,
    statusMessage: null,
    fullResponse: data,
    output: {
      answer: answer,
    },
    title: reportTitle,
    type: 'arit',
    promptInputs: [
      {
        variable_name: 'taaw',
        answer: taaw,
      },
      {
        variable_name: 'text',
        answer: text,
      },
    ],
  };
  return returnData;
}

async function createIms({
  obj,
  spo,
  region,
  ta,
  language,
}: {
  obj: string;
  spo: string;
  region: string;
  ta: string;
  language: string;
}) {
  const { data } = await axios.post(imsReqUrl!, {
    params: {
      obj,
      spo,
      region,
      ta,
      language,
    },
    project: '4950a1c24bab-49af-beb3-d127e70c4c59',
  });
  
  if (!data?.output?.answer) {
    throw new Error('Invalid IMS API response: missing output.answer');
  }

  const returnData = {
    status: data.status,
    statusMessage: null,
    fullResponse: data,
    url: data.output.answer,
    title: 'Untitled Ims Report',
    type: 'ims',
    promptInputs: [
      {
        variable_name: 'obj',
        answer: obj,
      },
      {
        variable_name: 'spo',
        answer: spo,
      },
      {
        variable_name: 'region',
        answer: region,
      },
      {
        variable_name: 'ta',
        answer: ta,
      },
    ],
  };
  return returnData;
}

async function getImsResults(url: string, promptInputs: any) {
  const { data } = await axios.get(url);

  const isPlainObject = Object.prototype.toString.call(data) === '[object Object]';
  let answer = data;

  if (!isPlainObject) {
    const jsonStart = data.indexOf('{"articles":');
    const jsonEnd = data.lastIndexOf('}') + 1;
    answer = data.substring(jsonStart, jsonEnd);

    answer = answer
      // Handle Unicode quotes
      .replace(/[\u2018\u2019\u201A\u201B\u201C\u201D\u201E\u201F\u2032\u2035\u2033\u2034]/g, '"')
      // Remove escaped unicode
      .replace(/\\u[\dA-F]{4}/gi, '')
      // Handle backslashes
      .replace(/\\(?!["\\/bfnrt])/g, '')
      // Fix escaped quotes
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, '\\')
      // Remove only control characters
      .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
      // Fix spaces between quotes
      .replace(/" +"/g, '" "')
      // Fix HTML entities
      .replace(/&quot;/g, '"')
      // Fix double quotes
      .replace(/""/g, '"')
      // Fix trailing commas
      .replace(/,\s*]/g, ']')
      .replace(/,\s*}/g, '}')
      // Fix line breaks
      .replace(/\r?\n/g, ' ')
      .trim();

    // Normalize whitespace
    answer = answer.replace(/\s+/g, ' ');

    try {
      answer = jsonrepair(answer);
      answer = JSON.parse(answer);
    } catch (e) {
      throw e;
    }
  }

  return {
    status: 'complete',
    statusMessage: null,
    fullResponse: data,
    output: {
      answer: answer,
    },
    title: 'Untitled IMS Report',
    type: 'ims',
    promptInputs,
  };
}
export const byRelevance = {
  createArit,
  createIms,
  getImsResults,
};
